import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CityStateZipAddress } from '@rivethealth/data/address';
import { USStates } from '@rivethealth/data/estimation';

@Component({
  selector: 'address-input',
  templateUrl: './address-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressInputComponent {
  constructor() {}

  @Input()
  value: CityStateZipAddress = {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
  };

  fireValueChange() {
    this.valueChange.emit(this.value);
  }

  @Output()
  readonly valueChange = new EventEmitter<CityStateZipAddress>();

  readonly states: string[] = USStates;
}
